import React from 'react';

import {Container, CloseButtonContainer} from './styles';

import {AiFillCloseCircle} from 'react-icons/ai';

interface ShowContainerProps {
  children: JSX.Element;
  setShowContainer: (value: boolean) => void;
}

const ShadowContainer: React.FC<ShowContainerProps> = ({
  children,
  setShowContainer,
}) => {
  const handleCloseClick = () => setShowContainer(false);

  return (
    <Container>
      <CloseButtonContainer onClick={handleCloseClick}>
        <AiFillCloseCircle />
      </CloseButtonContainer>
      {children}
    </Container>
  );
};

export default ShadowContainer;
